<template>
    <TransitionRoot as="template" :show="open">
        <Dialog class="relative z-101" @close="close">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500/75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-101 w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md">
                            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div class="sm:flex sm:items-start">
                                    <div :class="[
                                        'mx-auto flex size-12 shrink-0 items-center justify-center rounded-full sm:mx-0 sm:size-10',
                                        variant === 'info' ? 'bg-royal-blue-100' : 'bg-red-100'
                                    ]">
                                        <InformationCircleIcon v-if="variant === 'info'" class="size-6 text-royal-blue-600" aria-hidden="true" />
                                        <ExclamationTriangleIcon v-else class="size-6 text-red-600" aria-hidden="true" />
                                    </div>
                                    <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                        <DialogTitle as="h3" class="text-base font-semibold text-gray-900">{{ title }}</DialogTitle>
                                        <div class="mt-2">
                                            <p class="text-sm text-gray-500">{{ message }}</p>
                                            <p v-if="secondMessage" class="mt-2 text-sm font-bold text-gray-600">{{ secondMessage }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                <button type="button" class="mb-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:mb-0 sm:w-auto cursor-pointer" @click.stop="close" ref="cancelButtonRef">{{ $t('common.cancel') }}</button>
                                <button
                                    type="button"
                                    :class="[
                                        'inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-xs sm:mr-3 sm:w-auto cursor-pointer',
                                        variant === 'info' ? 'bg-royal-blue-600 hover:bg-royal-blue-500' : 'bg-red-600 hover:bg-red-500'
                                    ]"
                                    @click.stop.prevent="confirmAction">{{ buttonText }}</button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/vue/24/outline'

export default defineComponent({
    name: "DeleteFolderConfirmationModalComponent",

    emits: ['close', 'confirmAction'],

    components: {
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,

        ExclamationTriangleIcon,
        InformationCircleIcon,
    },

    props: {
        open: {
            type: Boolean,
            required: true,
        },

        title: {
            type: String,
            default: '',
        },

        message: {
            type: String,
            default: '',
        },

        secondMessage: {
            type: String,
            default: '',
        },

        buttonText: {
            type: String,
            default: '',
        },

        variant: {
            type: String as PropType<'danger' | 'info'>,
            default: 'danger',
        },
    },

    methods: {
        close() {
            this.$emit('close');
        },
        confirmAction() {
            this.$emit('confirmAction');
        },
    },
});
</script>
